import {enableProdMode, importProvidersFrom} from '@angular/core'

import {environment} from './environments/environment'
import {AppComponent} from './app/app.component'
import {ManagerModule} from './app/manager/manager.module'
import {ComitesModule} from './app/comites/comites.module'
import {OrganigrammeModule} from './app/organigramme/organigramme.module'
import {MonEquipeModule} from './app/mon-equipe/mon-equipe.module'
import {OAuthModule} from 'angular-oauth2-oidc'

import {PopoverModule} from 'ngx-bootstrap/popover'
import {TooltipModule} from 'ngx-bootstrap/tooltip'
import {CollapseModule} from 'ngx-bootstrap/collapse'
import {BsDropdownModule} from 'ngx-bootstrap/dropdown'
import {provideAnimations} from '@angular/platform-browser/animations'
import {NgxSpinnerModule} from 'ngx-spinner'
import {NgxDatatableModule} from '@swimlane/ngx-datatable'
import {ToastrModule} from 'ngx-toastr';
import {ToastModule} from 'src/app/shared/ui/toast/toast.module'
import {routes} from './app/app.routes'
import {CustomModalModule} from './app/shared/ui/custom-modal/custom-modal.module'
import {bootstrapApplication, BrowserModule} from '@angular/platform-browser'
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http'
import {AuthJWTInterceptor} from './app/core/interceptors/auth-jwt.interceptor'
import {ErrorInterceptor} from './app/core/interceptors/error.interceptor'
import {provideRouter, withComponentInputBinding, withInMemoryScrolling} from '@angular/router'
import { provideNgxWebstorage } from 'ngx-webstorage'
import { AllCommunityModule, ModuleRegistry, provideGlobalGridOptions } from 'ag-grid-community';

// Register all community features
ModuleRegistry.registerModules([AllCommunityModule]);

// Mark all grids as using legacy themes
provideGlobalGridOptions({ theme: "legacy"});

if (environment.production) {
    enableProdMode()
}

bootstrapApplication(AppComponent, {
    providers: [
        provideRouter(
            routes,
            withComponentInputBinding(),
            withInMemoryScrolling({scrollPositionRestoration: 'enabled'})
        ),
        provideNgxWebstorage(),
        importProvidersFrom(
            BrowserModule,
            CustomModalModule,
            ToastModule,
            ToastrModule.forRoot(),
            NgxDatatableModule,
            NgxSpinnerModule,
            BsDropdownModule,
            CollapseModule,
            TooltipModule,
            PopoverModule,
            OAuthModule.forRoot({
                resourceServer: {
                    allowedUrls: [environment.baseUrl],
                    sendAccessToken: false,
                },
            }),
            MonEquipeModule,
            OrganigrammeModule,
            ComitesModule,
            ManagerModule,
        ),
        {provide: HTTP_INTERCEPTORS, useClass: AuthJWTInterceptor, multi: true},
        {provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true},
        provideHttpClient(withInterceptorsFromDi()),
        provideAnimations(),
    ],
}).catch((err) => console.error(err))
